import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';

declare module 'vue/types/vue' {
  interface Vue {
    formatDate: (value: string | number, customTimezone: string) => string;
  }
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

/**
 * Formats a timestamp or timestamp into a lll format
 * @param {string} value - A date or a timestamp
 * @param {string} customTimezone optional - A custom timezone
 * @return string - The formatted date
 */
export default (value: string | number, customTimezone = '') => {
  if (!value) return '';
  return customTimezone ? dayjs(value).tz(customTimezone).format('lll') : dayjs(value).tz().format('lll');
};
